/**
 * @file SNCC（So-net光）固有のCSSスタイル定義
 *
 * SNCC事業者向けのロゴ画像やレイアウトのカスタマイズ。
 * レスポンシブ対応（SP用のメディアクエリ含む）。
 * styled-jsxのグローバルCSSとして出力される。
 */
import css from 'styled-jsx/css';
import url from '@/utils/config';

export default css.global`
  header .inner .logo .nurotop .label {
    background: url('${url('/images/label-globalLogo.png')}') no-repeat 0 0;
  }

  @media screen and (max-width: 640px) {
    header .inner .logo .nurotop .label {
      height: 17px !important;
      background: url('${url('/images/label-nuro-sp@2x.png')}') no-repeat 50% 50%;
      background-size: 100% 100%;
    }
  }

  #footer .copyright {
    overflow: hidden;
    font-size: 11px;
    height: 14px;
  }

  .buttonArea a.left {
    float: left;
  }

  .buttonArea a.left a {
    float: left;
  }

  .my-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .agreement-block {
    border: 1px gray solid;
    border-radius: 5px;
    padding: 0.5em;
  }
`;
